import React from "react";
import ModalDrawer from "../../../common/components/organisme/ModalDrawer/ModalDrawer";
import EditUserForm from "../../../features/user/components/CreateUserForm/CreateUserForm";
import useQueryURL from "../../../common/hooks/useQueryURL";

const MODAL_ID = "edit-user-modale";
export default function EditUserPage() {
  const {removeQueryValue} = useQueryURL();

  const onSuccessfulSubmit = () => {
    removeQueryValue([MODAL_ID]);

  }
  return (
    <div>
      <EditUserForm isUpdate onSuceess={onSuccessfulSubmit}/>
    </div>
  );
}

export function EditUserModale() {

  return (
    <ModalDrawer title="Modifier" urlParamName={MODAL_ID}>
      <EditUserPage />
    </ModalDrawer>
  );
}
